<template>
  <div
    class="w-full h-auto py-[3.75vw] bg-[linear-gradient(to_bottom,#FFFFFF_70%,#F5F5F7_30%)]"
  >
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          合作申请
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          携手共创未来，开启青少年科技教育新篇章
        </div>
      </div>
      <div
        class="w-full h-auto mx-auto flex flex-col justify-center items-center"
      >
        <div
          class="text-[0.83vw] text-[#676B73] font-harmony font-normal text-center"
        >
          无论您是教育机构、科技企业、创新工作室，还是同样怀揣梦想的个人，只要您热爱航空事业，<br />
          愿意与我们一起探索未知，我们期待与您携手并进。通过资源共享、课程联合开发、活动共办等多种合作模式，我们可以共同为青少年<br />
          搭建更广阔的舞台，让梦想的种子在科技的土壤中茁壮成长。
        </div>
      </div>
    </div>
    <!-- 描述文字区域 -->

    <!-- 表单区域 -->
    <div
      class="w-[61.46vw] h-[12.14vw] px-[14.83vw] py-[2.60vw] bg-[#05358c] rounded-2xl flex flex-col justify-between mx-auto"
    >
      <Form />

      <!-- 提示文本 -->
      <div
        class="w-full h-[2.5vw] min-h-0 flex flex-col justify-end text-white text-[0.63vw] leading-[1.25vw] font-light font-harmony"
      >
        <p>
          <i class="el-icon-warning"></i>
          请认真、如实、详细填写信息，客服人员会及时与您联系确认。
        </p>
        <p style="text-indent: 1.35em">
          此审批报告仅作初步审核的依据，对您所提供的一切，本公司承诺绝对保密。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "@/components/FormSubmit/Form.vue";

export default {
  name: "joinus-module5",
  components: {
    Form,
  },
};
</script>

<style scoped>
</style>